import { Conversation, Interaction } from '@quadminds/client-apis/agents';
import { ConversationItem, ConversationType } from '../../types/Conversation/Conversation';

export const fromConversationToConversationItem = (conversation: Conversation): ConversationItem => {
    // Extract conversation ID from interactions if main _id is empty
    let conversationId = conversation._id;
    if (!conversationId && conversation.interactions && conversation.interactions.length > 0) {
        conversationId = conversation.interactions[0].conversation_id || '';
    }

    return {
        title: conversation.title,
        conversationId: conversationId,
        status: conversation.status,
        metadata: conversation.metadata,
        created_at: conversation.created_at,
    };
};

export const fromInteractionToConversationType = (interaction: Interaction): ConversationType[] => {
    const result = [] as ConversationType[];
    if (interaction.user_message) {
        result.push({
            text: interaction.user_message,
            sender: 'user',
            files: [],
            interactionId: interaction._id,
        });
    }
    if (interaction.agent_response) {
        result.push({
            interactionId: interaction._id,
            text: interaction.agent_response,
            sender: 'agent',
            files: [],
            animated: false,
            rating: interaction?.rating,
            attachments: interaction?.attachments,
        });
    }
    return result;
};
